import React from "react"
import StudySkillsPost from "../../../components/study-skills-post"

export default () => <StudySkillsPost id="interleaving" />
